<template>
  <div class="modal_dim on"><!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>{{ data.applyType === 1 ? '교육' : '시험' }} 접수 확인</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="modal_txt">
              <p>
                외식경영관리사 {{ data.applyType === 1 ? '교육 신청' : '자격시험 접수'}} 후에는<br>
                신청내용을 변경할 수 없습니다.<br>
                <br>
                <b>{{ data.applyType === 1 ? '교육' : '시험' }}을 접수하시겠습니까?</b>
              </p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="$emit('eventClose')">이전으로</button>
              <button class="btn" @click="fnComplete">{{ data.applyType === 1 ? '교육' : '시험' }} 신청하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-edu-apply-popup',
  props: {
    data: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      required: true
    }
  },
  methods: {
    fnComplete: function(e) {
      this.callBack(e)
      this.$emit('eventClose')
    }
  }
}
</script>

<style scoped>

</style>
